<template>
  <ModalDialog :show="show" size="md">
    <template v-slot:tilte> Create a Spellingframe Account </template>
    <div class="sf-modal-body">
      <div class="tw-mb-8">
        <div>
          <span class="account-name">Individual Account</span>
          <span class="account-price">£10 for 12 months</span>
        </div>
        <ul class="sf-bullets">
          <li>Access all word lists, games and activities</li>
          <li>Track your spelling scores over time</li>
          <li>Create your own personalised lists</li>
          <li>
            Automatically see your 'Tricky Words' - the words you get wrong in
            tests, and practise these words separately
          </li>
        </ul>
        <div class="account-link">
          <SfRouterLink to="/register/individual">
            Create an individual account
          </SfRouterLink>
        </div>
      </div>
      <div class="tw-mb-8">
        <div>
          <span class="account-name">School Account</span>
          <span class="account-price">£30 for 12 months</span>
        </div>
        <ul class="sf-bullets">
          <li>
            Every student has their own personal username and password and can
            access all spelling lists, games and activities
          </li>
          <li>
            Teachers can schedule differentiated word lists for individual
            students, or groups, in their class
          </li>
          <li>
            Teachers can see the results whenever their students take a test and
            can track the progress over time of a student, group or whole class
          </li>
          <li>
            Students earn 'Spelling Points' by playing games and activities and
            can see their position on the class/school leaderboard (optional)
          </li>
          <li>
            When a student gets a word wrong in a test, it is added to their own
            personalised 'Tricky Word' list. They can then practise with those
            words they find tricky until they get them right
          </li>
        </ul>
        <div class="account-link">
          <SfRouterLink to="/register/school">
            Create an individual account
          </SfRouterLink>
        </div>
      </div>
    </div>
    <div class="sf-modal-footer">
      <SfRouterLink to="/register" class="sf-btn-primary">
        Register
      </SfRouterLink>
      <a href="" @click.prevent="$emit('closed')" class="sf-btn-secondary">
        Close
      </a>
    </div>
  </ModalDialog>
</template>

<style scoped lang="postcss">
.account-name {
  @apply tw-inline-block tw-pr-4 tw-text-[26px] tw-text-primary tw-font-bold;
}

.account-price {
  @apply tw-text-[14px] tw-font-bold;
}

.account-link {
  @apply tw-text-right tw-mt-2 tw-mb-4;
}
</style>

<script lang="ts">
import { defineComponent } from "vue";
import ModalDialog from "../ui/ModalDialog.vue";
import SfRouterLink from "./SfRouterLink.vue";

export default defineComponent({
  components: { ModalDialog, SfRouterLink },
  props: {
    show: Boolean,
  },
  data() {
    return {};
  },
});
</script>
